import type { Shadows } from '@mui/material/styles/shadows';

export const shadowThemeOptions = ['none', '0px 0px 30px rgb(0 0 0 / 0.1)', ...Array(23).fill('none')] as Shadows;
